import { createRender } from './types';

export const render = createRender(({ onDismissed }) => (
	<button onClick={() => onDismissed}>This is a Post Office Test Message</button>
));

export default render;
